import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class RootOnlyGuard implements CanActivate {
  
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(): boolean | UrlTree {
    const permission = this.authService.getPermission();
    
    if (permission === 'ROOT') {
      return true;
    }
    
    // Se não for ROOT, redireciona para editar a própria empresa
    const clinicId = this.authService.getClinicId();
    if (clinicId) {
      return this.router.createUrlTree(['main', 'v2', 'company', clinicId, 'edit']);
    }
    
    // Fallback: redireciona para home
    return this.router.createUrlTree(['main', 'v2']);
  }
}
